<template>
  <div class="abbr-home-container">
    <div class="archive-head">
      <img src="../../assets/images/logo.png" alt="" />
    </div>
    <div class="search-content">
      <!-- <h1>Idea Searcher</h1> -->
      <h1>
        <img
          src="../../assets/images/idea-searcher.jpg"
          alt=""
          srcset=""
          width="250px"
        />
      </h1>

      <div class="input-item">
        <el-input
          placeholder="Enter the paper title here and start exploring"
          v-model="keyword"
          class="input-with-select"
          @keyup.enter.native="handleSearch"
        >
          <!-- <el-select v-model="select" slot="prepend" placeholder="请选择">
            <el-option
              v-for="item in titleOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select> -->
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleSearch"
          ></el-button>
        </el-input>
      </div>

      <div class="select-item">
        <el-radio-group v-model="searchType">
          <el-radio label="title">Title</el-radio>
          <el-radio label="description">Description</el-radio>
          <!-- <el-radio label="deep">Deep Decomposer</el-radio>
          <el-radio label="youqi">油气文献</el-radio> -->
          <!-- <el-radio label="title">
            <el-dropdown placement="bottom">
              <span class="el-dropdown-link">
                Title<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item class="title-option" v-for="item in titleOptions" :key="item.value" @click.native="handleTitlTypeChange(item)">
                  <i :class="{'el-icon-check': item.value === titleType, 'iconfont': item.value !== titleType}"></i>
                  {{ item.label }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-radio>
          <el-radio label="keywords">Keywords</el-radio>
          <el-radio label="question">Question</el-radio> -->
        </el-radio-group>
      </div>
    </div>
    <el-dialog
      :show-close="false"
      :close-on-click-modal="false"
      :visible.sync="showDeepDialog"
      width="720px"
    >
      <el-row style="margin-bottom: 24px">
        <el-col :span="3">
          <img src="./user.png" alt="" srcset="" width="64px" />
        </el-col>
        <el-col :span="21">
          <el-input v-model="keyword"></el-input>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="3">
          <img src="./logo.png" alt="" srcset="" width="48px" />
        </el-col>
        <el-col :span="21">
          <article class="tip-text">
            I've decomposed your query into fundamental sub-questions to guide a
            deeper and more structured research process. Let me know if you need
            any adjustments before I begin.
          </article>

          <!-- <el-row v-for="(item, index) in apiTxtList" :key="index">
            <el-col :span="20">
              <article class="api-text">{{ item }}</article>
            </el-col>
            <el-col :span="4" style="text-align: right;">
              <el-button type="primary" plain size="mini" round>Edit Plan</el-button>
            </el-col>
          </el-row> -->
          <el-table
            :data="apiTxtList"
            border
            style="width: 100%"
            :show-header="false"
          >
            <el-table-column label="API">
              <template slot-scope="scope">
                <p
                 v-if="updatingApiId !== scope.row.id"
                >
                  {{ scope.row.apiTxt }}
                </p>
                <el-input v-model="updatingTxt" v-else/> 
              </template>
            </el-table-column>
            <el-table-column label="Tool" width="110">
              <!-- handleClick(scope.row) -->
              <template slot-scope="scope">
                <el-button type="primary" plain size="mini" round @click="startUpdating(scope.row)" v-if="updatingApiId !== scope.row.id"
                  >Edit Plan</el-button
                >
                <el-button type="primary" plain size="mini" round @click="saveApiText(scope.row)" v-else
                  >Save Plan</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <div class="dialog-footer">
        <el-button size="medium" @click="closeDialog">Cancel</el-button>
        <el-button size="medium" type="primary" @click="routerPush"
          >Start Research</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      keyword: "",
      titleType: "problem",
      searchType: "title",
      titleOptions: [
        {
          value: "problem",
          label: "Problem",
        },
        {
          value: "method",
          label: "Method",
        },
        {
          value: "contribution",
          label: "Contribution",
        },
      ],
      updatingApiId: -1,
      apiTxtList: [
        {
          id: 0,
          apiTxt:
            "What are the fundamental principles and components of hybrid architectures in machine learning?",
        },
        {
          id: 1,
          apiTxt:
            "How are reconstruction-based techniques implemented in machine learning models?",
        },
        {
          id: 2,
          apiTxt:
            "What are the key applications and use cases of hybrid architectures in reconstruction-based techniques?",
        },
        {
          id: 3,
          apiTxt:
            "What are the advantages and limitations of hybrid architectures in reconstruction-based techniques compared to traditional methods?",
        },
        {
          id: 4,
          apiTxt:
            "What recent advancements or innovations exist in hybrid architectures for reconstruction-based techniques?",
        },
      ],
      showDeepDialog: false,
      updatingTxt: '',
      // updatingFlag: false
    };
  },
  methods: {
    handleSearch() {
      if (this.searchType === "deep") {
        this.showDeepDialog = true;
        return;
      }
      this.routerPush();
    },
    routerPush() {
      this.$router.push({
        name: "abbr-search",
        query: {
          keyword: this.keyword,
          type: this.searchType,
          // title: this.titleType
        },
      });
    },
    handleTitlTypeChange(item) {
      this.titleType = item.value;
    },
    closeDialog() {
      this.showDeepDialog = false;
    },
    saveApiText(item) {
      this.updatingApiId = -1
      this.updatingTxt = ''
      console.log('item', item)
    },
    startUpdating(item) {
      this.updatingApiId = item.id
      this.updatingTxt = item.apiTxt
    }
  },
};
</script>
<style lang="less" scoped>
.abbr-home-container {
  .archive-head {
    width: 100%;
    background-color: #0275d8;
    color: white;
    font-size: 16px;
    height: 54px;
    padding: 10px 15px;
    display: flex;
    align-items: center;
    img {
      width: 100px;
    }
  }
  .search-content {
    margin: 120px auto;
    width: 900px;
    h1 {
      font-size: 54px;
      font-weight: 900;
      text-align: center;
      margin-bottom: 18px;
      color: #0962bc;
    }
  }
  .select-item {
    text-align: center;
    margin-top: 32px;
    font-size: 16px;
  }
}
.tip-text {
  line-height: 20px;
  margin-bottom: 12px;
  font-style: italic;
  color: #4874cb;
  font-weight: 500;
}
</style>
<style lang="less">
.abbr-home-container {
  .input-with-select {
    height: 54px;
    font-size: 16px;
  }
  .el-input-group .el-input__inner {
    height: 54px;
    line-height: 54px;
  }
  .el-input-group__prepend {
    width: 140px;
    line-height: 54px;
    box-sizing: border-box;
  }
  .el-input-group__append {
    .el-button {
      font-size: 22px;
      font-weight: 900;
    }
  }
  .el-dropdown {
    font-size: 15px;
  }
}
.title-option {
  i {
    color: #409eff;
    font-weight: 900;
  }
  .iconfont {
    display: inline-block;
    width: 14px;
  }
}
.dialog-footer {
  text-align: right;
  margin-top: 36px;
}
</style>


// WEBPACK FOOTER //
// src/pages/AbbrHome/index.vue